
import * as SDV from '@shapediver/viewer'
import * as SDVInteractions from '@shapediver/viewer.features.interaction'
import * as SDVAttributeVisualization from '@shapediver/viewer.features.attribute-visualization'

(<any>window).SDV = SDV;
(<any>window).SDVInteractions = SDVInteractions;
(<any>window).SDVAttributeVisualization = SDVAttributeVisualization;
